var map = {
	"./da.json": 5185,
	"./de.json": 43529,
	"./en-US.json": 46668,
	"./en.json": 30286,
	"./en_US.json": 71059,
	"./es.json": 41271,
	"./fjordkraft_no.json": 80832,
	"./fr.json": 38933,
	"./it.json": 29553,
	"./nb.json": 84296,
	"./nl.json": 92150,
	"./nn.json": 88447,
	"./no.json": 72274,
	"./sv.json": 43512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86026;